import React from 'react';

import SidebarTemplate from 'components/templates/SidebarTemplate';
import WorkingHoursAddForm from 'components/organismos/master/attend/WorkingHoursAddForm';

const TermMasterAddPage: React.FC = () => {

  return (
    <SidebarTemplate>
      <WorkingHoursAddForm />
    </SidebarTemplate>
  );
};

export default TermMasterAddPage;
